import * as signalR from "@microsoft/signalr";

/**
 * SignalR Connection Manager
 * Following the reference from the test HTML but adapted for Next.js environment
 */

const HUB_URL = process.env.NEXT_PUBLIC_SIGNALR_URL;
if (!HUB_URL) {
  throw new Error("NEXT_PUBLIC_SIGNALR_URL is not configured");
}
export const createSignalRConnection = () => {
  const connection = new signalR.HubConnectionBuilder()
    .withUrl(HUB_URL, {
      // For HttpOnly cookies, this must be true
      withCredentials: true,
      // If the backend requires a token in the header specifically,
      // we would use accessTokenFactory here.
      // But since cookies are used, withCredentials should handle it.
      // accessTokenFactory: () => { ... }
    })
    .withAutomaticReconnect()
    .configureLogging(signalR.LogLevel.Information)
    .build();

  return connection;
};

// Singleton instance to prevent multiple connections
let connectionInstance: signalR.HubConnection | null = null;

export const getSignalRConnection = () => {
  if (!connectionInstance) {
    connectionInstance = createSignalRConnection();
  }
  return connectionInstance;
};
